export default __webpack_public_path__ + "static/media/4747.11a1ddad.png";